import { extractStringValueSet } from './extract-properties';

export class IHCStain {

    static readonly MMR: string = 'mmr';
    static readonly PDL1_22C3: string = 'pd-l1-22c3';
    static readonly PDL1_28_8: string = 'pd-l1-28-8';
    static readonly C_MET: string = 'c-met';
    static readonly AXL: string = 'axl';
    static readonly CD73: string = 'cd73';
    static readonly Arginase: string = 'arginase';
    static readonly HER2: string = 'her2';
    static readonly CD166: string = 'cd166';
    static readonly PDL1_SP142: string = 'pd-l1-sp142';
    static readonly H_AND_E: string = 'h-and-e';
    static readonly PDL1_SP263: string = 'pd-l1-sp263';
    static readonly CLAUDIN_18: string = 'claudin-18';

    protected static _valueSet: Set<string> = null;
    static get values(): Set<string> {

        if (!this._valueSet) {
            this._valueSet = new Set();
            this._valueSet = extractStringValueSet(this);
        }

        return new Set(this._valueSet);
    }
}
